<script setup lang="ts">
const route = useRoute()

const head = useLocaleHead({
    addDirAttribute: true,
    identifierAttribute: "id",
    addSeoAttributes: true,
})

const { t } = useI18n()

const title = computed(() => {
    return route.meta.title ? `${t(route.meta.title)} - ${t("LREZ00061")}` : t("LREZ00061")
})

const show = process.dev
</script>

<template>
    <Html
        :lang="head.htmlAttrs ? head.htmlAttrs.lang : undefined"
        :dir="head.htmlAttrs ? head.htmlAttrs.dir : undefined"
    >
        <Head>
            <Title>{{ title }}</Title>
            <template v-for="link in head.link" :key="link.id">
                <Link :id="link.id" :rel="link.rel" :href="link.href" :hreflang="link.hreflang" />
            </template>
            <template v-for="meta in head.meta" :key="meta.id">
                <Meta :id="meta.id" :property="meta.property" :content="meta.content" />
            </template>
        </Head>
        <Body>
            <NLayout position="absolute">
                <NLayout has-sider position="absolute">
                    <LayoutReservationSider v-if="show" />
                    <NLayout embedded>
                        <slot />
                    </NLayout>
                </NLayout>
            </NLayout>
        </Body>
    </Html>
</template>

<style lang="scss" scoped>
.header {
    width: 100%;
    display: flex;
    align-items: center;
    height: 50px;
    padding: 8px 16px;
    &::v-deep() {
        .n-page-header {
            width: 100%;
        }
    }
}
</style>
